import axios, {AxiosResponse } from 'axios';
import { Url } from '../general/modules/url';
import { getProjectNameByCurrentPlatform } from '../constants/projectName';
import { PayserviceRequestError } from './PayserviceRequestError';

export class PayServiceApi {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static async get<T>(inUrl: string, data?: any): Promise<T> {
        const url = Url.getPayserviceUrl(inUrl);

        return axios.get(url, {
            data
        }).then(PayServiceApi.handleResponse);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static async post<T>(inUrl: string, data?: any): Promise<T> {
        const url = Url.getPayserviceUrl(inUrl);
        const name = getProjectNameByCurrentPlatform();
        const sendData = {...data};
        sendData.token = window.app.config.user_auth_token;
        sendData.gameName = name;
        return axios.post(url, sendData).then(PayServiceApi.handleResponse);
    }

    public static handleResponse = (response: AxiosResponse) => {
        if (response.data.error) {
            throw new PayserviceRequestError(response.data.error.message, response.data.error.code);
        }

        return response.data.result;
    }
}
